import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { getActividadesAplicacionPlantelThunk } from "../../../store/reducers/seleccionAplicacion/actividades-aplicacion-plantel/ActividadesAplicacionPlantel.thunks";
import {
  clearActividadesAplicacionPlantelError,
  resetActividadesAplicacionPlantel,
  setPage,
} from "../../../store/reducers/seleccionAplicacion/actividades-aplicacion-plantel/ActividadesAplicacionPlantel.reducer";
import Loader from "../../UI/Loader";
import Alert from "../../UI/Alert";
import Pagination from "../../UI/Pagination";
import EmptyState from "../../UI/EmptyState";
import ActividadesAplicacionHeaderPlantel from "./ActividadesAplicacionHeaderPlantel";
import ActividadesAplicacionPlantelTable from "./ActividadesAplicacionPlantelTable";
import ActividadAplicacionViewModalPlantel from "./ActividadAplicacionViewModalPlantel";
import ActividadAplicacionFormModalPlantel from "./ActividadAplicacionFormModalPlantel";
import ConfirmToggleActividadAplicacionPlantel from "./ConfirmToggleActividadAplicacionPlantel";

const ActividadesAplicacionListLayerPlantel = () => {
  const dispatch = useDispatch();
  const { plantelId } = useParams();
  const { list, loading, error, page, pageSize, search, talentoFilter, count } =
    useSelector((state) => state.actividadesAplicacionPlantel);
  //   console.log(plantelId)

  useEffect(() => {
    if (!plantelId) return;
    dispatch(
      getActividadesAplicacionPlantelThunk({
        plantelId,
        page,
        search,
        talento: talentoFilter,
      }),
    );
  }, [dispatch, plantelId, page, search, talentoFilter]);

  useEffect(() => {
    return () => {
      dispatch(resetActividadesAplicacionPlantel());
    };
  }, [dispatch]);

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <ActividadesAplicacionHeaderPlantel />

        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearActividadesAplicacionPlantelError())}
          />
        )}

        {loading ? (
          <Loader center text="Cargando actividades..." delay={200} />
        ) : (
          <>
            {search && (
              <div className="mb-3 d-flex align-items-center gap-2 text-secondary-light">
                <Icon icon="mdi:information-outline" width="18" />
                <span className="text-sm">
                  {count > 0 ? (
                    <>
                      Se {count === 1 ? "encontró" : "encontraron"}{" "}
                      <strong className="text-primary">{count}</strong>{" "}
                      {count === 1 ? "resultado" : "resultados"} para "{search}"
                    </>
                  ) : (
                    <>No se encontraron resultados para "{search}"</>
                  )}
                </span>
              </div>
            )}

            {list.length === 0 ? (
              <EmptyState
                icon={
                  search || talentoFilter
                    ? "mdi:magnify-remove-outline"
                    : "mdi:magnify-remove-outline"
                }
                title={
                  search || talentoFilter
                    ? "No se encontraron actividades"
                    : "No hay actividades registradas"
                }
                description={
                  search || talentoFilter
                    ? "Intenta con otra búsqueda o filtro"
                    : "Comienza agregando una nueva actividad"
                }
              />
            ) : (
              <>
                <ActividadesAplicacionPlantelTable
                  actividades={list}
                  search={search}
                />
                <Pagination
                  page={page}
                  count={count}
                  pageSize={pageSize}
                  onPageChange={(newPage) => dispatch(setPage(newPage))}
                />
              </>
            )}
          </>
        )}
      </div>

      <ActividadAplicacionViewModalPlantel />
      <ActividadAplicacionFormModalPlantel />
      <ConfirmToggleActividadAplicacionPlantel />
    </div>
  );
};

export default ActividadesAplicacionListLayerPlantel;
